module.exports = __webpack_public_path__ + "static/media/tractor-pin.b59a4217.svg";